'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var global = {};

exports.default = global;
